import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { makeUnauthenticatedPOSTRequest } from "../../services/serverHelper";
import { toast } from "react-toastify";
import { endpoints } from "../../services/apis";
import "react-toastify/dist/ReactToastify.css";
import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";

import logo from '../../../assets/ek-logo.png';
import partnerBg from "../../../assets/partner-bg.png"; 
import Footer from '../../../components/Footer';
import './PartnersSignup.css';

const numbersArray = Array.from({ length: 250 }, (_, index) => index + 1);

function PartnerSignup() {
  const navigate = useNavigate();
  const [checkbox, setCheckbox] = useState(true);
  const [passwordVisible, setPasswordVisible] = useState(false);

  // CHANGED: Default role set to "Partner"
  const [formData, setFormData] = useState({
    role: "Partner", 
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    passwordConfirm: "",
    phoneNumber: {
      countryCode: "+91",
      number: ""
    }
  });

  function changeHandler(event) {
    const { name, value } = event.target;
    if (name.startsWith("phoneNumber.")) {
      setFormData((prev) => ({
        ...prev,
        phoneNumber: {
          ...prev.phoneNumber,
          [name.split(".")[1]]: value
        }
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  }

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const Otp_Send = async (reqBody) => {
    try {
      const response = await fetch(endpoints.REGISTER_OTP_SEND, {
        method: "POST",
        headers: { "content-Type": "application/json" },
        body: JSON.stringify(reqBody)
      });
      if (response.status === 200) {
        toast.success("Otp has been sent...", { position: "top-center" });
      }
    } catch (error) {
      console.log(error);
      toast.error(error.message);
    }
  };

  // Google Login success handler
  const handleGoogleSignupSuccess = async (credentialResponse) => {
    try {
      const decoded = jwtDecode(credentialResponse.credential);
      console.log("Google User Info:", decoded);

      const toastId = toast.loading("Logging in with Google...");
      
      const response = await makeUnauthenticatedPOSTRequest(
        endpoints.LOGIN_WITH_EMAIL,
        {
          email: decoded.email,
          googleIdToken: credentialResponse.credential,
          registerBy: "google",
        }
      );

      toast.dismiss(toastId);

      if (!response || response.error || response.status !== "success") {
        toast.error(
          response?.message ||
            response?.error ||
            "Google login failed. Please try again."
        );
        return;
      }

      const { accessToken, refreshToken, role } = response.data || {};

      if (!accessToken || !refreshToken) {
        toast.error("Google login failed. Try again.");
        return;
      }

      // CHANGED: Check for Partner role
      if (role !== "Partner") {
        toast.error("Only Partners/Artists can login here");
        return;
      }

      // Save tokens in localStorage
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("refreshToken", refreshToken);
      localStorage.setItem("role", role);

      toast.success("Google login successful!");
      navigate("/Partner_Profile");
    } catch (error) {
      console.error("Google login error:", error);
      toast.error("Google login failed. Please try again.");
    }
  };

  const handleGoogleSignupError = () => {
    toast.error("Google signup failed");
  };

  const submitHandler = async (event) => {
    event.preventDefault();
    if (!checkbox) return toast.error("Agree to the Terms and Conditions");
    if (formData.password !== formData.passwordConfirm)
      return toast.error("Passwords do not match", { position: "top-center" });
    if (formData.phoneNumber.number.length !== 10)
      return toast.error("Please provide a valid phone number", {
        position: "top-center"
      });

    const toastId = toast.loading("Loading...");
    try {
      const response = await makeUnauthenticatedPOSTRequest(
        endpoints.REGISTER_API,
        formData
      );

      if (response.status === "error") {
        const msg = response.message;
        if (msg?.includes("valid email")) toast.error("Email is not valid");
        else if (msg?.includes("already in use"))
          toast.error("Email is already registered");
        else if (msg?.includes("valid phoneNumber"))
          toast.error("Please provide a valid phone number");
        else toast.error(msg);
      } else if (response.status === "success") {
        const reqBody = {
          email: formData.email,
          mobileNu: formData.phoneNumber.number,
          registerBy:
            formData.email && formData.phoneNumber.number
              ? "both"
              : formData.email
              ? "email"
              : "mobile"
        };
        Otp_Send(reqBody);
        toast.success("Successfully registered", { position: "top-center" });

        // Save user details for pre-filling login form
        localStorage.setItem('prefill_email', formData.email);
        localStorage.setItem('prefill_phone_number', formData.phoneNumber.number);
        localStorage.setItem('prefill_country_code', formData.phoneNumber.countryCode);

        navigate(`/verifyCode/${formData.email}`, {
          state: { mobile: formData.phoneNumber.number },
        });
      }
    } catch (error) {
      console.log(error);
    }
    toast.dismiss(toastId);
  };

  return (
    <>
      <div className="partner-signup-wrapper">
        {/* Background */}
        <div className="partner-signup-background">
          <img
            src={partnerBg}
            alt="background"
            className="partner-signup-bg-image"
          />
          <div className="partner-signup-bg-overlay"></div>
        </div>

        {/* Main form card */}
        <div className="partner-signup-content">
            <div className="partner-signup-card">
                <div className="partner-signup-header">
                    <img src={logo} alt="logo" className="partner-signup-logo" />
                    <h2 className="partner-signup-title">
                        Sign up as Partner
                    </h2>
                    <p className="partner-signup-subtitle">Create your artist account</p>
                </div>

                {/* Google Sign-Up Button */}
                {/* <div className="partner-google-signup-btn">
                  <GoogleLogin
                    onSuccess={handleGoogleSignupSuccess}
                    onError={handleGoogleSignupError}
                  />
                </div> */}

                <div className="partner-divider">
                  <div className="partner-divider-line"></div>
                  <span className="partner-divider-text">OR</span>
                  <div className="partner-divider-line"></div>
                </div>

                <form onSubmit={submitHandler} className="partner-signup-form">
                    <div className="partner-name-row">
                        <input 
                          required 
                          type="text" 
                          name="firstName" 
                          placeholder="First Name" 
                          value={formData.firstName} 
                          onChange={changeHandler} 
                          className="partner-input partner-input-half" 
                        />
                        <input 
                          required 
                          type="text" 
                          name="lastName" 
                          placeholder="Last Name" 
                          value={formData.lastName} 
                          onChange={changeHandler} 
                          className="partner-input partner-input-half" 
                        />
                    </div>
                    
                    <div className="partner-phone-row">
                        <select 
                          name="phoneNumber.countryCode" 
                          value={formData.phoneNumber.countryCode || "+91"} 
                          onChange={changeHandler} 
                          className="partner-country-select"
                        >
                            {numbersArray.map((number) => (
                                <option key={number} value={`+${number}`}> +{number} </option>
                            ))}
                        </select>
                        <input 
                          required 
                          name="phoneNumber.number" 
                          type="number" 
                          pattern="[0-9]{10}" 
                          placeholder="Phone Number" 
                          maxLength={10} 
                          value={formData.phoneNumber.number} 
                          onChange={changeHandler} 
                          className="partner-input partner-phone-input" 
                        />
                    </div>
                    
                    <input 
                      required 
                      type="email" 
                      name="email" 
                      placeholder="Email address" 
                      value={formData.email} 
                      onChange={changeHandler} 
                      className="partner-input" 
                    />
                    
                    <div className="partner-password-field">
                        <input 
                          required 
                          name="password" 
                          placeholder="Password" 
                          minLength={8} 
                          type={passwordVisible ? "text" : "password"} 
                          value={formData.password} 
                          onChange={changeHandler} 
                          className="partner-input" 
                        />
                        <span 
                          onClick={togglePasswordVisibility} 
                          className="partner-eye-icon"
                        >
                            <i className={`fas ${passwordVisible ? "fa-eye-slash" : "fa-eye"}`}></i>
                        </span>
                    </div>
                    
                    <input 
                      required 
                      name="passwordConfirm" 
                      type={passwordVisible ? "text" : "password"} 
                      value={formData.passwordConfirm} 
                      onChange={changeHandler} 
                      placeholder="Confirm Password" 
                      className="partner-input" 
                    />
                    
                    <div className="partner-checkbox-row">
                        <input 
                          type="checkbox" 
                          checked={checkbox} 
                          onChange={() => setCheckbox((prev) => !prev)} 
                        />
                        <p 
                          onClick={() => navigate("/termAndCondition")} 
                          className="partner-terms-text"
                        >
                            I Agree to the Terms and Conditions
                        </p>
                    </div>
                    
                    <button type="submit" className="partner-register-btn">
                        Register
                    </button>
                    
                    <p className="partner-login-link">
                        Already have an account?{" "}
                        <span 
                          className="partner-login-link-text" 
                          onClick={() => navigate("/partnerlogin")}
                        >
                            Login
                        </span>
                    </p>
                </form>
            </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default PartnerSignup;